import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import React, { useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";

const useStyles = makeStyles({
  root: {
    marginBottom: "40px",
  },
  button: {
    backgroundColor: "#306F9D",
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "#306F9D",
    },
  },
});

function EditMenuPage({ disabled, ...props }) {
  const {
    control,
    handleSubmit,
  } = useForm();
  const classes = useStyles();
  const [data, setData] = useState(null);
  const { setLoading } = useLoading();

  const id = props.match.params.id;

  const getMenu = async () => {
    setLoading(true);
    const result = await apiHelper.hknt.hkntGetMenuById(id);
    setData(result.data);
    setLoading(false);
  };

  const onSubmit = async (values) => {
    console.log(values);
    setLoading(true);
    try {
      const result = await apiHelper.hknt.hkntUpdateMenu(id, values);
      console.log(result.data);
      toast.dark("Your changes is saved.");
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMenu();
  }, []);

  return (
    data && (
      <div>
        <Grid container xs={12} md={8} lg={6}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <fieldset disabled={disabled} className="fieldset">
              <Typography variant="h4" gutterBottom>
                Menu > Edit Menu
              </Typography>
              <Box
                display="flex"
                flexDirection="column"
                className={classes.root}
              >
                <Controller
                  name="localizations.en.title"
                  control={control}
                  defaultValue={data.localizations.en.title}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      margin="dense"
                      label="Menu Title (English)"
                      variant="outlined"
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      helperText={
                        error
                          ? error.message
                          : "The name is how it appears on your site."
                      }
                    />
                  )}
                  rules={{ required: "Menu Title (English) required" }}
                />
                <Controller
                  name="localizations.tc.title"
                  control={control}
                  defaultValue={data.localizations.tc.title}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      margin="dense"
                      label="Menu Title (Traditional Chinese)"
                      variant="outlined"
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      helperText={
                        error
                          ? error.message
                          : "The name is how it appears on your site."
                      }
                    />
                  )}
                  rules={{
                    required: "Menu Title (Traditional Chinese) required",
                  }}
                />
                <Controller
                  name="slug"
                  control={control}
                  defaultValue={data.slug}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      margin="dense"
                      label="Slug"
                      variant="outlined"
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      disabled
                      helperText={
                        error
                          ? error.message
                          : "The “slug” is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens."
                      }
                    />
                  )}
                />
              </Box>
              <Grid xs={6} md={4} lg={4}>
                {disabled || (
                  <Button
                    className={classes.button}
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Save Changes
                  </Button>
                )}
              </Grid>
            </fieldset>
          </form>
        </Grid>
      </div>
    )
  );
}

export default EditMenuPage;
